<template>
  <footer class="vdb-footer">
    <div class="vdb-footer-inner">
    <div class="vdb-footer-grid">
      <div>
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 14px">
          <span class="vdb-logo-mark" style="background: white; color: var(--ink-800)">VD</span>
          <span style="font-weight: 600; font-size: 16px; color: white">VideoDatabase</span>
        </div>
        <p style="font-size: 13px; line-height: 1.55; color: rgba(255,255,255,0.6); max-width: 320px; margin: 0">
          A hand-curated reference library of short-form video that actually performs. Studied, tagged, and broken down — so you can stop guessing.
        </p>
      </div>
      <div>
        <h4>Browse</h4>
        <ul>
          <li><router-link to="/videos" humblytics="footer-videos">All videos</router-link></li>
          <li><router-link to="/topics" humblytics="footer-topics">Topics</router-link></li>
          <li><router-link to="/formats" humblytics="footer-formats">Formats</router-link></li>
          <li><router-link to="/concepts" humblytics="footer-concepts">Concepts</router-link></li>
          <li><router-link to="/elements" humblytics="footer-elements">Elements</router-link></li>
          <li><router-link to="/creators" humblytics="footer-creators">Creators</router-link></li>
          <li><router-link to="/hooks" humblytics="footer-hooks">Hooks</router-link></li>
        </ul>
      </div>
      <div>
        <h4>Tools</h4>
        <ul>
          <li><router-link to="/submit-video" humblytics="footer-submit-video">Submit a video</router-link></li>
          <li><router-link to="/swipefiles" humblytics="footer-swipefiles">Swipefiles</router-link></li>
          <li v-if="ideaRoomLink"><router-link to="/ideas" humblytics="footer-idea-generator">Idea Generator</router-link></li>
          <li><router-link to="/signup" humblytics="footer-creator-panel">Creator panel</router-link></li>
          <li><router-link to="/signup" humblytics="footer-hook-templates">Hook templates</router-link></li>
          <li><router-link to="/tools/instagram-reels-size" humblytics="footer-reels-size-checker">Reels size checker</router-link></li>
          <li><router-link to="/mcp/install" humblytics="footer-mcp-install">Connect AI with MCP <small>Beta</small></router-link></li>

        </ul>
      </div>
      <div>
        <h4>About</h4>
        <ul>
          <li><router-link to="/about" humblytics="footer-about">Who built this?</router-link></li>
          <li><a href="https://cut30.co" target="_blank" rel="noopener" humblytics="ext-site-cut30">Cut30 bootcamp</a></li>
          <li><router-link to="/cut30-content-review" humblytics="footer-cut30-content-reviews">Content reviews</router-link></li>
          <li><router-link to="/updates" humblytics="footer-updates">Updates</router-link></li>
          <li><router-link to="/blog" humblytics="footer-blog">Blog</router-link></li>
          <li><a href="mailto:hello@videodatabase.io" humblytics="footer-email">hello@videodatabase.io</a></li>
        </ul>
      </div>
    </div>
    <div class="vdb-footer-bottom">
      <span>&copy; 2026 VideoDatabase</span>
      <span class="vdb-italic">Built for people who'd rather study than guess.</span>
    </div>
    </div>
  </footer>
</template>

<script>
// The Idea Generator link ships with the launch: set VUE_APP_IDEA_ROOM_LINK=true at build time together with
// IDEA_ROOM_ENABLED, so visitors never land on "not available yet".
const IDEA_ROOM_LINK = process.env.VUE_APP_IDEA_ROOM_LINK === 'true';

export default {
  name: 'VdbFooter',
  data() {
    return { ideaRoomLink: IDEA_ROOM_LINK };
  },
};
</script>

<style scoped>
.vdb-footer-grid > div { min-width: 0; }
.vdb-footer-grid a { overflow-wrap: anywhere; }
</style>
